import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import trailer from "../img/trailer.png";
import play from "../img/play.png";
import colaboradores from "../img/colaboradores2.png";
import colaborador from "../img/colaboradores.png";

import ReactPlayer from "react-player";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

function getModalStyle() {
  return {
    top: `${50}%`,
    left: `${50}%`,
    transform: `translate(-${50}%, -${50}%)`,
  };
}

const toDriveDownload = (pdf) => {
  if (!pdf) return pdf;
  if (pdf.includes('drive.google.com')) {
    const byFile = pdf.match(/\/d\/([A-Za-z0-9_-]+)/);
    if (byFile) return `https://drive.google.com/uc?export=download&id=${byFile[1]}`;
    return pdf;
  }
  const match = pdf.match(/^([A-Za-z0-9_-]{20,})(\/view\?usp=.*)?$/);
  if (match) {
    return `https://drive.google.com/uc?export=download&id=${match[1]}`;
  }
  return pdf;
};

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: "#151515",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: "25px",
    width: "fit-content",
  },
}));

export default function SimpleModal(props) {
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    console.log(open);
  };
  const handleClickAway = () => {
    setOpen(false);
  };

  if (props.tipo == "trailer") {
    return (
      <div className="ctnportada" onClick={handleOpen}>
        <img src={trailer} alt="trailer"></img>
        <p>TRAILER</p>

        <Modal open={open} onClose={handleClose} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
          <div style={modalStyle} className={classes.paper}>
            <p onClick={handleClose} className="xmodal">x</p>
            <ClickAwayListener onClickAway={handleClickAway}>
              <ReactPlayer
                controls={true}
                url={props.t}
                config={{ vimeo: { playerOptions: { playsinline: false, autoplay: true } } }}
              />
            </ClickAwayListener>
          </div>
        </Modal>
      </div>
    );
  } else if (props.tipo == "play" || props.tipo == "leer" || props.tipo == "leer-texto") {
    const downloadUrl = toDriveDownload(props.t);
    return (
      <div className="ctnportada" onClick={handleOpen}>
        {props.tipo == "leer" ? (
          <div style={{ width: '46px', height: '46px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '30px', lineHeight: 1 }} aria-label="download">⌄̲</div>
        ) : props.tipo == "leer-texto" ? (
          <img src={colaboradores} alt="leer"></img>
        ) : (
          <img src={play} alt="play"></img>
        )}
        <p>{props.tipo == "leer" || props.tipo == "leer-texto" ? "LEER" : "PLAY"}</p>

        <Modal open={open} onClose={handleClose} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
          <div style={modalStyle} className={classes.paper}>
            <p onClick={handleClose} className="xmodal">x</p>
            <ClickAwayListener onClickAway={handleClickAway}>
              {props.tipo == "leer" || props.tipo == "leer-texto" ? (
                <div style={{ position: 'relative' }}>
                  <a
                    href={downloadUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Descargar PDF"
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      width: '78px',
                      height: '78px',
                      background: '#000',
                      zIndex: 20,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textDecoration: 'none',
                      boxShadow: '0 0 0 2px #000'
                    }}
                  >
                    <div style={{ color: '#fff', fontSize: '9px', letterSpacing: '0.06em', textAlign: 'center', lineHeight: 1.15 }}>
                      ⬇<br />DESCARGAR
                    </div>
                  </a>
                  <iframe
                    title="Lectura"
                    src={props.t}
                    style={{ width: '70vw', height: '80vh', border: 0, background: '#fff', display: 'block' }}
                  />
                </div>
              ) : (
                <ReactPlayer
                  controls={true}
                  url={props.t}
                  config={{ vimeo: { playerOptions: { playsinline: false, autoplay: true } } }}
                />
              )}
            </ClickAwayListener>
          </div>
        </Modal>
      </div>
    );
  } else if (props.tipo == "colaboradores") {
    return (
      <div className="colaboradores" onClick={handleOpen}>
        <img src={colaboradores} alt="colaboradores"></img>

        <Modal open={open} onClose={handleClose} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
          <div style={modalStyle} className={classes.paper}>
            <p onClick={handleClose} className="xmodal">x</p>
            <ClickAwayListener onClickAway={handleClickAway}>
              <div>
                <div style={{ backgroundImage: `url(${colaborador})`, height: "700px", width: "500px", backgroundPositionX: "center", display: "flex" }}>
                  <div className="colabm">
                    <p>Si te ha gustado lo que hacemos y cómo lo hacemos, te invitamos a compartirlo con tus amigxs, difundir y conocer más de nuestra cooperativa en navegando nuestro sitio web.</p>
                  </div>
                </div>
              </div>
            </ClickAwayListener>
          </div>
        </Modal>
      </div>
    );
  } else if (props.tipo == "episodio") {
    return (
      <div className="cajaepisodio">
        <img src={props.img} alt={props.i.nombre} onClick={handleOpen}></img>
        <h1 onClick={handleOpen}>{props.i.nombre} </h1>
        <h2>E{props.i.numeroepisodio} T{props.temp} <span style={{ color: "#e2e2e2" }}>{props.i.duracion} MINUTOS</span></h2>
        <p>{props.i.descripcion}</p>
        <Modal open={open} onClose={handleClose} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
          <div style={modalStyle} className={classes.paper}>
            <p onClick={handleClose} className="xmodal">x</p>
            <ClickAwayListener onClickAway={handleClickAway}>
              <ReactPlayer
                controls={true}
                url={props.t}
                config={{ vimeo: { playerOptions: { playsinline: false, autoplay: true } } }}
              />
            </ClickAwayListener>
          </div>
        </Modal>
      </div>
    )
  }

  return null;
}
